import { Sport } from '__generated__/globalTypes';

export type CardType = 'Card' | 'BaseballCard' | 'NBACard';

export const cardTypes: Record<Sport, CardType> = {
  [Sport.FOOTBALL]: 'Card',
  [Sport.BASEBALL]: 'BaseballCard',
  [Sport.NBA]: 'NBACard',
} as const;
